/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";

// 등록하기 팝업
function TeacherSearch(props) {
    const token = localStorage.getItem("token");
    const { login, onAfterTeacherSearchClick, onHideTeacherSearchClick, tcidParent } = props;
    const [rows, setRows] = useState([]);
    const [centers, setCenters] = useState([]);
    const [tcid, setTcid] = useState(tcidParent);
    const columns = [
        { field: "id", headerName: "id", hide: true },
        {
            field: "center", headerName: "센터명", width: 130, align: "center",
            renderCell: (params) => {
                return <>{params.row.center} {params.row.location}</>
            }

        },
        { field: "tname", headerName: "이름", width: 130, align: "center" },
        { field: "tphone", headerName: "연락처", width: 130, align: "left" },
        { field: "regdate", headerName: "가입일", width: 130, align: "center" },
    ];
    const [sname, setSname] = useState("");
    const [sphone, setSphone] = useState("");

    const onSearchClick = async () => {
        let result = await axios.post(configState.api + "/gympass_admin/search_teacher", {
            token: token,
            level: login.level,
            mcd: login.mcd,
            cid: login.cid,
            tcid: tcid,
            sname: sname,
            sphone: sphone,
        });
        if (result.data.success) {
            setRows(result.data.rows);
        }
        else {
            setRows([]);
        }
    };

    return (
        <Box sx={{ m: 2 }}>
            {/* 가맹점 */}
            <Box>
                <CenterSelect
                    login={login}
                    tcidParent={tcid}
                    setTcidParent={setTcid}
                />
            </Box>

            <Box display="flex" sx={{ mt: 1 }}>
                {/* 이름 */}
                <Box
                >
                    <TextField
                        sx={{ width: 120 }}
                        name="sname"
                        label="이름"
                        size="small"
                        onChange={(e) => setSname(e.target.value)}
                        autoComplete="off"
                        value={sname}
                    ></TextField>
                </Box>

                {/* 연락처 */}
                <Box
                >
                    <TextField
                        sx={{ width: 160, ml: 1 }}
                        name="sphone"
                        label="연락처"
                        size="small"
                        autoComplete="off"
                        value={sphone}
                        onChange={(e) => setSphone(e.target.value)}
                    ></TextField>
                </Box>
                <Button
                    sx={{ ml: 1 }}
                    variant="contained" onClick={onSearchClick} size="small">
                    조회
                </Button>
            </Box>

            <DataGrid
                sx={{ minHeight: 350, mt: 1 }}
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[5]}
                checkboxSelection={false}
                onRowClick={(params, event) => {
                    // pr(params.id);
                    // pr(params.row.mb_name);
                    onAfterTeacherSearchClick({ id: params.id, name: params.row.tname, phone: params.row.tphone });
                    onHideTeacherSearchClick();
                }}
            />
        </Box>
    );
}

export default TeacherSearch;
